import { Component, OnInit } from '@angular/core';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { AuthenticatedUser, MarketingStoreSettings } from '@quorum/models/xs-resource';
import { Observable } from 'rxjs';
import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'quorum-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
})
export class SettingsComponent implements OnInit {
  authenticatedUser$: Observable<AuthenticatedUser>;
  constructor(private authenticationService: AuthenticationStateService) {}

  ngOnInit(): void {
    this.authenticatedUser$ = this.authenticationService
      .selectAuthenticatedUser()
      .pipe(filter((authenticatedUser) => authenticatedUser != null));
  }
}
